import React, { Component } from "react";
class Element extends Component {
    componentDidMount() {
        document
            .querySelector("body")
            .addEventListener("keypress", this.handleClick);
    }

    returnElementByType = (type, firstLetter, secondLetter, spacing) => {
        let space = null;
        let element = {};
        let symbol = null;
        switch (spacing) {
            case "3":
                space = "margin3";
                break;
            case "2":
                space = "margin2";
                break;
            case "1":
                space = "margin1";
                break;
        }
        switch (type) {
            case "1":
                symbol = (
                    <p className={`letters-holder ${space}`}>
                        <span className="left-letter">{secondLetter}</span>
                        <span className="center-letter">{firstLetter}</span>
                        <span className="right-letter">{secondLetter}</span>
                    </p>
                );
                break;
            case "2":
                symbol = (
                    <p className={`letters-holder ${space}`}>
                        {/* <span className="left-letter">{firstLetter}</span>
                    <span className="center-letter">{secondLetter}</span>
                    <span className="right-letter">{firstLetter}</span> */}
                        <span className="left-letter">{secondLetter}</span>
                        <span className="center-letter">{firstLetter}</span>
                        <span className="right-letter">{secondLetter}</span>
                    </p>
                );
                break;
            case "3":
                symbol = (
                    <p className={`letters-holder ${space}`}>
                        <span className="left-letter">{secondLetter}</span>
                        <span className="center-letter">{firstLetter}</span>
                        <span className="right-letter">{secondLetter}</span>
                    </p>
                );
                break;
            case "4":
                symbol = (
                    <p className={`letters-holder ${space}`}>
                        {/* <span className="left-letter">{firstLetter}</span>
                    <span className="center-letter">{secondLetter}</span>
                    <span className="right-letter">{firstLetter}</span> */}
                        <span className="left-letter">{secondLetter}</span>
                        <span className="center-letter">{firstLetter}</span>
                        <span className="right-letter">{secondLetter}</span>
                    </p>
                );
                break;
        }
        element.show = symbol;
        element.aimStimul = firstLetter;
        element.distractor = secondLetter;
        return element;
    };

    handleClick = event => {
        if (event.keyCode != 32) {
            const { attributes, startTime, timeOut, automaticAnswer } = {
                ...this.props
            };
            const element = this.returnElementByType(
                attributes.type,
                attributes.firstLetter,
                attributes.secondLetter,
                attributes.spacing
            );
            this.props.fillAnswer(
                event.key ? event.key : "",
                startTime,
                attributes.realAnswer,
                automaticAnswer,
                timeOut,
                attributes.firstLetter,
                attributes.secondLetter,
                attributes.spacing,
                attributes.type,
                element.aimStimul,
                element.distractor
            );
            document
                .querySelector("body")
                .removeEventListener("keypress", this.handleClick);
        }
    };

    render() {
        const { attributes, startTime, timeOut, automaticAnswer } = {
            ...this.props
        };
        const element = this.returnElementByType(
            attributes.type,
            attributes.firstLetter,
            attributes.secondLetter,
            attributes.spacing
        );
        if (automaticAnswer) {
            this.props.fillAnswer(
                "",
                startTime,
                attributes.realAnswer,
                automaticAnswer,
                timeOut,
                attributes.firstLetter,
                attributes.secondLetter,
                attributes.spacing,
                attributes.type,
                element.aimStimul,
                element.distractor
            );
            document
                .querySelector("body")
                .removeEventListener("keypress", this.handleClick);
        }
        console.log(element.show);

        return (
            <React.Fragment>
                {element.show}
                {/* <span className={attributes.className}>{attributes.value}</span> */}
            </React.Fragment>
        );
    }
}

export default Element;
